export const SET_SECOND_SESSION = 'SET_SECOND_SESSION';